<app-advisor-errorpage *ngIf="!hasResult"></app-advisor-errorpage>
<div *ngIf="hasResult">
  <div class="grid-x grid-margin-x headline-wrapper">
    <div class="headline cell small-12 large-12">
      <span *ngIf="anfrage?.programs?.length > 0" [innerHTML]=anfrage?.programs?.length></span>
      <h1 [innerHTML]="(textkeyPrefix + '.headline' + (anfrage?.programs?.length === 0 ? '.none' : isBundOnly? '.bund' : '')) | translate: placeholder"></h1>
    </div>
  </div>

  <div class="cell attention-callout" *ngIf="isFossilEnergy">
    <app-advisor-image path="/foc/foc-attention.svg"></app-advisor-image>
    <div class="attention-teaser">
      <h2 [innerHTML]="textkeyPrefix + '.attention.callout.fossil.' + fossilEnergyProgram + '.headline' | translate"></h2>
      <p [innerHTML]="textkeyPrefix + '.attention.callout.fossil.' + fossilEnergyProgram + '.text' | translate"></p>
      <a class="button signal2 inline-arrow-right" *ngIf="mocUrl" [href]="mocUrl" target="_blank" [innerHTML]="textkeyPrefix + '.attention.callout.button' | translate"></a>
    </div>
  </div>

  <app-honeypot *ngIf="!(this.isFossilEnergy && this.anfrage?.programs?.length === 0) && internalPortal" [anfrage]="anfrage" [clickTarget]="idTargetElement"></app-honeypot>

  <div class="cell programs" *ngIf="(anfrage?.programs?.length > 0 && internalPortal) || !internalPortal">
    <h2 id="funding-programs" class="text-center" [innerHTML]="textkeyPrefix + '.programs.headline' | translate: placeholder"></h2>
    <p [innerHTML]="textkeyPrefix + '.programs.text' | translate"></p>

    @if(forceDialog || showDownload) {
      <dialog-hint [clickTarget]="measuresWithoutProgram.length <= 0 ? idTargetElement : null"
                   [showPdfAndPrintIcons]="measuresWithoutProgram.length <= 0"
                   [textkey]="(textkeyPrefix + '.callout' + (measuresWithoutProgram.length > 0 ? '.no.programs' : '')) | translate: placeholder"
                   [closable]="true"></dialog-hint>
    }
    <div class="filter" *ngIf="anfrage?.programs?.length > 1 && (objectKeys(toggleMeasure)?.length > 1 || objectKeys(toggleFundingType).length > 1)">
      <h3 [innerHTML]="textkeyPrefix + '.sortierung.headline' | translate"></h3>
      <button type="button" class="filter" aria-controls="filter" [attr.aria-expanded]="toggleFilter" [attr.aria-label]="'arialabel.toggle.filter' | translate" (click)="onClickToggleFilter()"><i class="icon-chevron-down" [class.open]="toggleFilter" [class.close]="!toggleFilter"></i></button>
      <div id="filter" class="filter-co ntent" *ngIf="toggleFilter">
        <p *ngIf="objectKeys(toggleFundingType).length > 1" class="funding-types" [innerHTML]="textkeyPrefix + '.sortierung.art' | translate"></p>
        <button type="button" role="radio" aria-controls="programs-table" [attr.aria-expanded]="toggleFundingType[fundingType]"
                *ngFor="let fundingType of objectKeys(toggleFundingType)" class="sort-funding-type" (click)="toggleSelectedFundingType(fundingType)">
          <span class="custom-radio" [class.checked]="toggleFundingType[fundingType]"></span>
          <span [innerHTML]="(textkeyPrefix + '.art.' + fundingType) | translate"></span>
        </button>

        <div *ngIf="visiblePrograms?.length > 0 && objectKeys(toggleMeasure)?.length > 1">
        <p class="all-measures" [innerHTML]="textkeyPrefix + '.sortierung.massnahmen' | translate"></p>
        <button type="button" role="radio" aria-controls="programs-table"  [attr.aria-expanded]="toggleMeasure[selectedMeasure]"
                *ngFor="let selectedMeasure of objectKeys(toggleMeasure)" class="selected-measures" (click)="toggleSelectedMeasure(selectedMeasure)">
          <span class="custom-radio" [class.checked]="toggleMeasure[selectedMeasure]"></span>
          <span [innerHTML]="(textkeyPrefix + '.massnahme.' + selectedMeasure) | translate"></span>
        </button>
        </div>
      </div>
    </div>
    <table *ngIf="showForMediumUp" [id]="showForMediumUp ? 'programs-table' : null" [attr.aria-hidden]="!showForMediumUp" [attr.aria-live]="!showForMediumUp ? 'polite' : null">
      <tr>
        <th *ngIf="showForLargeOnly" [innerHTML]="textkeyPrefix + '.foerdermittel.foerdergeber' | translate"></th>
        <th [innerHTML]="textkeyPrefix + '.foerdermittel.programm' | translate"></th>
        <th *ngIf="showForMediumUp" [innerHTML]="textkeyPrefix + '.foerdermittel.art' | translate"></th>
        <th [innerHTML]="textkeyPrefix + '.foerdermittel.massnahmen' | translate"></th>
      </tr>
      <tr *ngFor="let program of getVisibleItems()">
        <td *ngIf="showForLargeOnly" [innerHTML]="program.foerdergeber_name"></td>
        <td [innerHTML]="program.name"></td>
        <td *ngIf="showForMediumUp">
          <span class="funding-type" [innerHTML]="(textkeyPrefix + '.art.' + program.art) | translate"></span>
        </td>
        <td>
          <ng-container *ngFor="let category of program.categories">
            <span class="category" *ngIf="toggleMeasure[category] === true || toggleMeasure.hasOwnProperty(category) === false" [innerHTML]="(textkeyPrefix + '.massnahme.' + category) | translate"></span>
          </ng-container>
        </td>
      </tr>
    </table>

  <table *ngIf="!showForMediumUp" [id]="!showForMediumUp ? 'programs-table' : null" [attr.aria-hidden]="showForMediumUp" [attr.aria-live]="!showForMediumUp ? 'polite' : null">
    <tbody  *ngFor="let program of getVisibleItems()">
      <tr>
        <th [innerHTML]="textkeyPrefix + '.foerdermittel.programm' | translate"></th>
      </tr>
      <tr>
        <td [innerHTML]="program.name"></td>
      </tr>
      <tr>
        <th [innerHTML]="textkeyPrefix + '.foerdermittel.art' | translate"></th>
      </tr>
      <tr>
        <td><span class="funding-type" [innerHTML]="(textkeyPrefix + '.art.' + program.art) | translate"></span></td>
      </tr>
      <tr>
        <th [innerHTML]="textkeyPrefix + '.foerdermittel.massnahmen' | translate"></th>
      </tr>
      <tr>
        <td>
          <ng-container *ngFor="let category of program.categories">
            <span class="category" *ngIf="toggleMeasure[category] === true || toggleMeasure.hasOwnProperty(category) === false" [innerHTML]="(textkeyPrefix + '.massnahme.' + category) | translate"></span>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>

    <h3 *ngIf="visiblePrograms.length <= 0 && anfrage?.programs?.length > 0" [innerHTML]="textkeyPrefix + '.no.visible.programs' | translate"></h3>

    <app-pagination *ngIf="visiblePrograms.length > 0" clickTarget="funding-programs" [itemCount]="countVisiblePrograms" [itemsPerPage]="itemsPerPage"
                    (onPageChange)="updateStartIndex($event)" ariaControlsTarget="programs-table"></app-pagination>
  </div>

  <div class="cell small-12" *ngIf="showDownload">
    <app-download [id]="idTargetElement" [url]="reportUrl" textkeyPrefix="foerdermittelcheck.ergebnis."></app-download>
  </div>


  <app-dialogform [id]="idTargetElement" *ngIf="forceDialog && anfrage?.programs?.length > 0" textkeyPrefix="foerdermittelcheck" advisorImagePath="/foc/foc-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)"></app-dialogform>

  <app-advisor-teaser *ngIf="mocUrl" [url]="mocUrl" [mailUrl]="mocUrl" [textPrefix]="textkeyPrefix + '.teaser.moc'" image="/foc/moc-teaser.svg"></app-advisor-teaser>
  <app-advisor-teaser *ngIf="sdcUrl" [url]="sdcUrl" [mailUrl]="sdcUrl" [textPrefix]="textkeyPrefix + '.teaser.sdc'" image="/foc/sdc-teaser.svg" changeColumnOrder="true"></app-advisor-teaser>
  <app-advisor-teaser *ngIf="wpcUrl" [url]="wpcUrl" [mailUrl]="wpcUrl" [textPrefix]="textkeyPrefix + '.teaser.wpc'" image="/foc/wpc-teaser.svg"></app-advisor-teaser>

  <app-dialogform [id]="idTargetElement" *ngIf="forceDialog && anfrage?.programs?.length <= 0 && !isFossilEnergy" textkeyPrefix="foerdermittelcheck" advisorImagePath="/foc/foc-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)"></app-dialogform>

  <app-portal-teaser></app-portal-teaser>
  <app-donate *ngIf="internalPortal === true" [textkeyPrefix]="textkeyPrefix"></app-donate>

</div>

<div class="grid-x grid-padding-x" *ngIf="hasResult">
  <div class="cell">
    <app-step-buttons [previousLink]="previousLink"
                      mediumWidthRight="10" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="10"
                      previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
  </div>
</div>
